import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '../../../commons/hooks/useQuery';

export const usePublisherRedirection = (condition, path, state = {}) => {
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { push } = useHistory();

  if (typeof condition !== 'boolean') {
    throw new Error('First parameter for usePublisherRedirection must be of type boolean');
  }

  useEffect(() => {
    if (condition) {
      push({
        pathname: `/publicador${path}`,
        search: `?postingId=${postingId}`,
        state
      });
    }
  }, [postingId, path, condition, push, state]);
};
